import dayjs from 'dayjs'

/**
 * API'den gelen ham belge verilerini işler
 *
 * @param {Array} documents - API'den gelen ham belge verileri
 * @param {Function} getFileTypeName - ID'den dosya türü adı alma fonksiyonu
 * @returns {Array} - İşlenmiş belge nesneleri
 */
export const processDocuments = (documents, getFileTypeName) => {
  if (!documents || !Array.isArray(documents)) {
    return []
  }

  return documents.map(doc => {
    // Orijinal typeId'yi koru
    const originalTypeId = doc.typeId

    return {
      ...doc,
      // TypeId için readableTypeId ekle ama orijinal typeId'yi koru
      readableTypeId: originalTypeId === 1 ? 'Dosya' : 'URL',
      typeId: originalTypeId, // Orijinal typeId'yi koru
      addDate: dayjs(doc.addDate).format('YYYY-MM-DD HH:mm'),
      description: doc.description || 'Açıklama yok',
      fileType: getFileTypeName(originalTypeId),
      // State değerini number olarak ayarla ve gelmiyorsa varsayılan olarak 1 (Analiz ediliyor) kullan
      state: doc.state ? Number(doc.state) : 1,
      assetId: doc.assetId || null,
    }
  })
}